document.addEventListener("facet:rendered", function () {
  WIMCardInit();
  WIMResizeProductCarousels();
});

document.addEventListener("DOMContentLoaded", function () {
  var recycledEl = document.getElementById("recycled_package");
  if (recycledEl) {
    recycledEl.addEventListener("change", function (event) {
      var recycledPackageValue = event.target.checked ? "Si" : "No";
      recycledEl.setAttribute("value", recycledPackageValue);
      document
        .querySelector("#CartDrawer-Form")
        .setAttribute("data-recycled-package", recycledPackageValue);
    });
  }

  WIMCardInit();
  WIMObserveProductCarousels();
});

window.addEventListener("load", function () {
  WIMResizeProductCarousels();
});

/* ------------------------------------------------------------------ */
/*  Flickity height fix: resize after layout settles & on scroll-in   */
/* ------------------------------------------------------------------ */

function WIMResizeProductCarousels() {
  if (typeof Flickity === "undefined") return;
  document
    .querySelectorAll(
      ".product-grid.flickity-enabled, .contains-card.flickity-enabled",
    )
    .forEach(function (el) {
      var flkty = Flickity.data(el);
      if (flkty) flkty.resize();
    });
}

function WIMObserveProductCarousels() {
  if (typeof IntersectionObserver === "undefined") return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (typeof Flickity === "undefined") return;
        var flkty = Flickity.data(entry.target);
        if (flkty) flkty.resize();
      });
    },
    { rootMargin: "200px" },
  );
  document
    .querySelectorAll(".product-grid.carousel, .contains-card.carousel")
    .forEach(function (el) {
      observer.observe(el);
    });
}

function WIMInitCarouselsIn(card) {
  card.querySelectorAll("[data-flickity-config]").forEach(function (el) {
    if (el.dataset.flickityReady) return;
    el.dataset.flickityReady = "true";
    var checkedInput =
      el.querySelector('input[type="radio"]:checked') ||
      el.querySelector('input[type="radio"][checked]');
    if (!checkedInput) {
      checkedInput =
        el.querySelector('input[type="radio"]:not(.disabled):not([disabled])') ||
        el.querySelector('input[type="radio"]');
      if (checkedInput) {
        checkedInput.checked = true;
        checkedInput.setAttribute("checked", "");
      }
    }
    var config = JSON.parse(el.getAttribute("data-flickity-config"));
    var flkty = new Flickity(el, config);
    var lastCell = flkty.cells[flkty.cells.length - 1];
    var needsScroll =
      lastCell &&
      lastCell.x + lastCell.size.outerWidth > flkty.size.innerWidth * 0.9;
    if (!needsScroll) {
      flkty.destroy();
      el.classList.add("flickity-no-scroll");
    }
    el.querySelectorAll('input[type="radio"][checked]').forEach(function (radio) {
      if (!radio.checked) radio.removeAttribute("checked");
    });
    checkedInput =
      el.querySelector('input[type="radio"]:checked') ||
      el.querySelector('input[type="radio"][checked]');
    if (checkedInput) {
      var cell = checkedInput.closest(".WIM-variant-cell");
      if (cell) cell.classList.add("wim-checked");
    }
  });
}

function WIMCardInit() {
  document
    .querySelectorAll(".WIM-product-card-wrapper")
    .forEach(function (card) {
      if (card.dataset.wimCardInit) return;
      card.dataset.wimCardInit = "true";
      card.addEventListener("mouseenter", function () {
        WIMInitCarouselsIn(card);
      });
      card.addEventListener("focusin", function () {
        WIMInitCarouselsIn(card);
      });
    });

  WIMColorSwapInit();
  WIMDesktopCardAddToCartOnSizeInit();
  WIMSyncWimCheckedOnRadioChange();
}

function WIMSyncWimCheckedOnRadioChange() {
  document.addEventListener("change", function (e) {
    var radio = e.target;
    if (!radio || radio.type !== "radio") return;
    var carousel = radio.closest(".WIM-product-variants-slider-wrapper");
    if (!carousel) return;
    carousel
      .querySelectorAll(".WIM-variant-cell.wim-checked")
      .forEach(function (cell) {
        cell.classList.remove("wim-checked");
      });
    var cell = radio.closest(".WIM-variant-cell");
    if (cell) cell.classList.add("wim-checked");
  });
}

/* ------------------------------------------------------------------ */
/*  Desktop: add to cart when a size is selected in the card slider    */
/* ------------------------------------------------------------------ */

function WIMTryAddCardVariantFromRadio(radio) {
  if (!radio || radio.type !== "radio") return false;

  var variantRadios = radio.closest("variant-radios");
  if (!variantRadios) return false;

  var card = variantRadios.closest(".WIM-product-card-wrapper");
  if (!card || card.closest(".wim-popup")) return false;

  var fieldset = radio.closest("fieldset");
  if (fieldset) {
    var optionName =
      (fieldset.querySelector("legend") &&
        fieldset.querySelector("legend").textContent.trim()) ||
      (fieldset.querySelector('input[type="radio"]') &&
        fieldset.querySelector('input[type="radio"]').name) ||
      "";
    var optionLower = optionName.toLowerCase();
    var isSizeOption =
      optionLower.indexOf("talla") !== -1 ||
      optionLower.indexOf("tamaño") !== -1 ||
      optionLower.indexOf("size") !== -1;
    if (!isSizeOption) return false;
  }

  var variantsEl = variantRadios.querySelector('script[type="application/json"]');
  if (!variantsEl) return false;

  var variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch (err) {
    return false;
  }

  var selectedValues = {};
  variantRadios.querySelectorAll("fieldset").forEach(function (fs, idx) {
    var checked =
      fs.querySelector("input[type=radio]:checked") ||
      fs.querySelector("input[type=radio][checked]");
    if (checked) selectedValues["option" + (idx + 1)] = checked.value;
  });

  var matched = null;
  for (var i = 0; i < variants.length; i++) {
    var isMatch = true;
    for (var k in selectedValues) {
      if (variants[i][k] !== selectedValues[k]) {
        isMatch = false;
        break;
      }
    }
    if (isMatch) {
      matched = variants[i];
      break;
    }
  }

  if (!matched || !matched.available) return false;

  var productId =
    variantRadios.dataset.section ||
    (variantRadios.id && variantRadios.id.replace("variant-radios-", ""));
  if (!productId) return false;
  var form =
    card.querySelector('form[data-type="add-to-cart-form"]') ||
    document.getElementById("product-form-" + productId);
  if (!form) return false;

  var hiddenInput = form.querySelector('input[name="id"]');
  if (hiddenInput) hiddenInput.value = String(matched.id);

  var submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
  if (submitBtn) {
    submitBtn.removeAttribute("disabled");
    submitBtn.removeAttribute("aria-disabled");
    if (submitBtn.querySelector("span") && !submitBtn.querySelector(".sold-out-message")) {
      submitBtn.querySelector("span").classList.remove("hidden");
    }
    if (submitBtn.querySelector(".sold-out-message")) {
      submitBtn.querySelector(".sold-out-message").classList.add("hidden");
    }
  }

  if (typeof form.requestSubmit === "function") {
    form.requestSubmit();
  } else if (submitBtn) {
    submitBtn.click();
  }

  return true;
}

function WIMDesktopCardAddToCartOnSizeInit() {
  document.addEventListener("change", function (e) {
    var radio = e.target;
    if (!radio || radio.type !== "radio") return;
    WIMTryAddCardVariantFromRadio(radio);
  });

  document.addEventListener("click", function (e) {
    var label = e.target.closest(".WIM-product-card-wrapper .WIM-variant-cell label");
    if (!label) return;

    var card = label.closest(".WIM-product-card-wrapper");
    if (!card) return;

    var inputId = label.getAttribute("for");
    if (!inputId) return;
    var radio = card.querySelector("#" + CSS.escape(inputId));
    if (!radio) return;

    // Fallback: if the clicked option is already selected, `change` won't fire.
    if (radio.checked) WIMTryAddCardVariantFromRadio(radio);
  });
}

/* ------------------------------------------------------------------ */
/*  Color-swap: dynamically update the product card on color click    */
/* ------------------------------------------------------------------ */

function WIMColorSwapInit() {
  document
    .querySelectorAll(".WIM-group-colors-wrapper")
    .forEach(function (wrapper) {
      if (wrapper.dataset.wimColorSwapInit) return;
      wrapper.dataset.wimColorSwapInit = "true";
      wrapper.addEventListener("click", WIMHandleColorSwap);
    });
}

function WIMFormatMoney(cents) {
  var locale = document.documentElement.lang || "es";
  var currency =
    (window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active) ||
    "EUR";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  }).format(cents / 100);
}

function WIMGetSizedUrl(src, width) {
  if (!src) return "";
  var raw = src.startsWith("//") ? "https:" + src : src;
  try {
    var url = new URL(raw);
    url.searchParams.set("width", String(width));
    return url.toString();
  } catch (_) {
    return src;
  }
}

function WIMBuildSrcset(src, maxWidth) {
  var widths = [165, 360, 533, 720, 940, 1066];
  var parts = [];
  for (var i = 0; i < widths.length; i++) {
    if (widths[i] <= maxWidth) {
      parts.push(WIMGetSizedUrl(src, widths[i]) + " " + widths[i] + "w");
    }
  }
  parts.push(WIMGetSizedUrl(src, maxWidth) + " " + maxWidth + "w");
  return parts.join(", ");
}

/* ---- main click handler ---- */

function WIMHandleColorSwap(e) {
  var colorLink = e.target.closest(".WIM-link-color");
  if (!colorLink) return;
  if (colorLink.classList.contains("WIM-link-color--more")) {
    var colorsWrapper = colorLink.closest(".WIM-group-colors-wrapper");
    if (colorsWrapper) {
      var selected = colorsWrapper.querySelector(".link--selected");
      var url =
        selected &&
        (selected.dataset.productUrl || selected.getAttribute("href"));
      if (url) window.location.href = url;
    }
    return;
  }
  if (colorLink.classList.contains("link--selected")) return;

  e.preventDefault();
  e.stopPropagation();

  var card = colorLink.closest(".WIM-product-card-wrapper");
  var colorsWrapper = colorLink.closest(".WIM-group-colors-wrapper");
  if (!card || !colorsWrapper) return;

  var handle = colorLink.dataset.productHandle;
  if (!handle) return;

  var discount = colorLink.dataset.discount || "0";

  var prev = colorsWrapper.querySelector(".link--selected");
  if (prev) prev.classList.remove("link--selected");
  colorLink.classList.add("link--selected");

  fetch("/products/" + handle + ".js")
    .then(function (r) {
      return r.json();
    })
    .then(function (product) {
      WIMUpdateCardImages(card, product);
      WIMUpdateCardLinks(card, product);
      WIMUpdateCardTitle(card, product);
      WIMUpdateCardPrice(card, product);
      WIMUpdateCardBadge(card, product, discount);
      WIMUpdateCardVariants(card, product);
      WIMUpdateQuickAction(card, product);
      WIMInitCarouselsIn(card);
      card.dataset.productHandle = handle;
    })
    .catch(function (err) {
      console.error("WIM color-swap error:", err);
    });
}

/* ---- images ---- */

function WIMUpdateCardImages(card, product) {
  var mediaContainer = card.querySelector(".card__media .media");
  if (!mediaContainer) return;

  var existingImg = mediaContainer.querySelector("img");
  var sizes = existingImg ? existingImg.getAttribute("sizes") : "";

  mediaContainer.innerHTML = "";

  var media = product.media || [];
  if (media.length === 0 && product.featured_image) {
    media = [
      {
        src: product.featured_image,
        width: 1066,
        height: 1066,
        media_type: "image",
        id: 0,
      },
    ];
  }

  var isFirst = true;
  for (var i = 0; i < media.length; i++) {
    if (media[i].media_type !== "image") continue;
    var src = media[i].src;
    var img = document.createElement("img");
    img.srcset = WIMBuildSrcset(src, media[i].width);
    img.src = WIMGetSizedUrl(src, 533);
    if (sizes) img.sizes = sizes;
    img.alt = media[i].alt || "";
    img.className = isFirst ? "motion-reduce show-image" : "motion-reduce";
    img.loading = "lazy";
    img.dataset.thumb = product.id + "-" + media[i].id;
    img.width = media[i].width;
    img.height = media[i].height;
    mediaContainer.appendChild(img);
    isFirst = false;
  }
}

/* ---- links ---- */

function WIMUpdateCardLinks(card, product) {
  var innerLink = card.querySelector("a.card__inner");
  if (innerLink) innerLink.setAttribute("href", product.url);

  var headingLink = card.querySelector(".card-wrap__content .card__heading a");
  if (headingLink) headingLink.setAttribute("href", product.url);
}

/* ---- title & meta ---- */

function WIMUpdateCardTitle(card, product) {
  var parts = product.title.split("_");
  var name = parts.length > 1 ? parts[parts.length - 1] : product.title;

  var innerHeading = card.querySelector(".card__inner .card__heading");
  if (innerHeading) innerHeading.textContent = name;

  var headingLink = card.querySelector(".card-wrap__content .card__heading a");
  if (headingLink) headingLink.textContent = name;

  if (parts.length <= 1) return;

  var category = parts[0];
  var gender = (parts[1] || "").trim();

  var metaEls = card.querySelectorAll(".product__title--meta");
  if (metaEls.length >= 1) {
    var catSpan = metaEls[0].querySelector("span");
    if (catSpan) {
      var genderSpan = catSpan.querySelector(".gender");
      catSpan.childNodes[0].textContent = category + " ";
      if (genderSpan) genderSpan.textContent = gender;
    }
  }
  if (metaEls.length >= 2) {
    var gSpan = metaEls[1].querySelector("span");
    if (gSpan) gSpan.textContent = gender;
  }
}

/* ---- price ---- */

function WIMUpdateCardPrice(card, product) {
  var priceWrapper = card.querySelector(".WIM-card-price-information-wrapper");
  if (!priceWrapper) return;

  var variant = null;
  for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].available) {
      variant = product.variants[i];
      break;
    }
  }
  if (!variant) variant = product.variants[0];

  var price = variant ? variant.price : product.price;
  var compareAt = variant ? variant.compare_at_price : product.compare_at_price;
  var isOnSale = compareAt && compareAt > price;
  var isSoldOut = !product.available;

  var priceDiv = priceWrapper.querySelector(".price");
  if (!priceDiv) return;

  priceDiv.classList.toggle("price--on-sale", !!isOnSale);
  priceDiv.classList.toggle("price--sold-out", isSoldOut);

  var regularItem = priceDiv.querySelector(
    ".price__regular .price-item--regular",
  );
  if (regularItem) regularItem.textContent = WIMFormatMoney(price);

  var saleContainer = priceDiv.querySelector(".price__sale");
  if (saleContainer) {
    saleContainer.innerHTML = "";

    if (isOnSale) {
      var compareSpanWrap = document.createElement("span");
      var compareS = document.createElement("s");
      compareS.className = "price-item price-item--regular";
      compareS.textContent = WIMFormatMoney(compareAt);
      compareSpanWrap.appendChild(compareS);
      saleContainer.appendChild(compareSpanWrap);
    }

    var saleSpan = document.createElement("span");
    saleSpan.className = "price-item price-item--sale price-item--last";
    saleSpan.textContent = WIMFormatMoney(price);
    saleContainer.appendChild(saleSpan);
  }
}

/* ---- badge ---- */

function WIMUpdateCardBadge(card, product, discount) {
  var badgeContainer = card.querySelector(".card__badge");
  if (!badgeContainer) return;

  var soldOutScheme = card.dataset.soldOutScheme || "";
  var saleScheme = card.dataset.saleScheme || "";
  var badge = badgeContainer.querySelector(".badge");

  if (!product.available) {
    if (!badge) {
      badge = document.createElement("span");
      badgeContainer.appendChild(badge);
    }
    badge.className = "badge badge--bottom-left " + soldOutScheme;
    badge.textContent = "Agotado";
    badge.style.display = "";
    return;
  }

  var disc = parseInt(discount, 10);
  if (disc > 0) {
    if (!badge) {
      badge = document.createElement("span");
      badgeContainer.appendChild(badge);
    }
    badge.className = "badge badge--bottom-left " + saleScheme;
    badge.textContent = Math.ceil(disc) + "%";
    badge.style.display = "";
    return;
  }

  if (badge) badge.style.display = "none";
}

/* ---- variant options ---- */

function WIMUpdateCardVariants(card, product) {
  var variantRadios = card.querySelector("variant-radios");
  var hoverWrapper = card.querySelector(".WIM-card-hover-variants");
  var isDefault =
    product.variants.length === 1 &&
    product.variants[0].title === "Default Title";

  if (isDefault) {
    if (hoverWrapper) hoverWrapper.style.display = "none";
    return;
  }
  if (hoverWrapper) hoverWrapper.style.display = "";
  if (!variantRadios) return;

  variantRadios.setAttribute("data-section", String(product.id));
  variantRadios.setAttribute("data-url", product.url);
  variantRadios.id = "variant-radios-" + product.id;

  var options = product.options;
  var variants = product.variants;
  var productFormId = "product-form-" + product.id;

  var firstAvailable = null;
  for (var i = 0; i < variants.length; i++) {
    if (variants[i].available) {
      firstAvailable = variants[i];
      break;
    }
  }
  if (!firstAvailable) firstAvailable = variants[0];

  var html = "";

  for (var oi = 0; oi < options.length; oi++) {
    var opt = options[oi];
    var optName = typeof opt === "object" && opt !== null ? opt.name : opt;
    var pos = oi + 1;
    var key = "option" + pos;

    var seen = {};
    var values = [];
    for (var vi = 0; vi < variants.length; vi++) {
      var val = variants[vi][key];
      if (val && !seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    }

    html += '<fieldset class="js product-form__input">';
    html +=
      '<legend class="form__label hidden">' +
      WIMEscapeHtml(optName) +
      "</legend>";
    html +=
      '<div id="WIM-carousel-' +
      product.id +
      "-" +
      pos +
      '" class="WIM-product-variants-slider-wrapper carousel"' +
      " data-flickity-config='" +
      JSON.stringify({
        pageDots: false,
        contain: true,
        cellAlign: "left",
      }) +
      "'>";

    for (var vii = 0; vii < values.length; vii++) {
      var v = values[vii];
      var checked = firstAvailable[key] === v;
      var available = false;
      for (var vj = 0; vj < variants.length; vj++) {
        if (variants[vj][key] === v && variants[vj].available) {
          available = true;
          break;
        }
      }
      var inputId = product.id + "-" + pos + "-" + vii;
      html += '<div class="WIM-variant-cell carousel-cell">';
      html +=
        '<input type="radio" id="' +
        inputId +
        '" name="' +
        WIMEscapeHtml(optName) +
        '" value="' +
        WIMEscapeHtml(v) +
        '" form="' +
        productFormId +
        '"' +
        (checked ? " checked" : "") +
        (!available ? ' class="disabled"' : "") +
        ">";
      html += '<label for="' + inputId + '">' + WIMEscapeHtml(v) + "</label>";
      html += "</div>";
    }

    html += "</div></fieldset>";
  }

  html +=
    '<script type="application/json">' +
    JSON.stringify(variants) +
    "</" +
    "script>";

  variantRadios.innerHTML = html;

  variantRadios
    .querySelectorAll("[data-flickity-config]")
    .forEach(function (el) {
      delete el.dataset.flickityReady;
      el.classList.remove("flickity-no-scroll");
    });
}

/* ---- quick-action button class ---- */

function WIMUpdateQuickAction(card, product) {
  var btn = card.querySelector(".quickview-mobile, .wim-quickadd");
  if (!btn) return;
  btn.className =
    product.variants.length > 1 ? "quickview-mobile" : "wim-quickadd";
}

/* ---- util ---- */

function WIMEscapeHtml(str) {
  var div = document.createElement("div");
  div.appendChild(document.createTextNode(str));
  return div.innerHTML;
}

/* JS SUB-MENU */
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".menu-drawer__navigation-container")
    .forEach((menuContainer) => {
      menuContainer.addEventListener("click", function (e) {
        const link = e.target.closest("a");

        if (!link) return;

        if (link.classList.contains("open-submenu")) {
          e.preventDefault();
          const parentLi = link.closest("li.has-submenu");
          parentLi.classList.add("open");
        }

        if (link.classList.contains("open-babymenu")) {
          e.preventDefault();
          const parentLi = link.closest("li.has-babymenu");
          parentLi.classList.add("open");
        }

        if (link.classList.contains("submenu-back-btn")) {
          e.preventDefault();
          const currentMenu = link.closest("ul");
          if (!currentMenu) return;

          const parentLi = currentMenu.parentElement;
          if (parentLi) {
            parentLi.classList.remove("open");
          }
        }

        if (link.classList.contains("open-accordion")) {
          e.preventDefault();

          const parentLi = link.closest("li.has-accordion");
          const container = link.closest("ul");

          if (!parentLi || !container) return;

          container
            .querySelectorAll("li.has-accordion.accor-open")
            .forEach((item) => {
              if (item !== parentLi) {
                item.classList.remove("accor-open");
              }
            });

          parentLi.classList.toggle("accor-open");
        }
      });
    });
});

/* END JS SUBMENU */
